// @ts-expect-error - TODO: fix this
import findLastIndexPolyfill from 'array.prototype.findlastindex'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FindLastIndex = <T>(array: T[], predicate: (value: T, index: number, obj: T[]) => unknown, thisArg?: any) => number
export const findLastIndex: FindLastIndex = findLastIndexPolyfill
